

import { useState } from "react";
import { LinkTargetProperties } from "../../../../global/components/linkSettings/interfaces";

type Tab = {
    label: string;
    content: React.ReactNode;
};

type TabsProps = {
    tabs: Tab[];
    contactUsPage: { url: string; target: LinkTargetProperties};
    privacyPage: { url: string; target: LinkTargetProperties};
    termsPage: { url: string; target: LinkTargetProperties};
};


const PaywallMyAccountTabs = ({tabs,contactUsPage,privacyPage,termsPage}: TabsProps) => {
    const [activeIndex, setActiveIndex] = useState(0);
    return (
        <div className="PaywallMyAccountTabsCont">
        <div className="PaywallMyAccountTabs">
            <div role="tablist" className="tabs-header">
                {tabs.map((tab, index) => (
                    <button
                        key={index}
                        role="tab"
                        aria-selected={activeIndex === index}
                        className={`tab-button ${activeIndex === index ? "active" : ""}`}
                        onClick={() => setActiveIndex(index)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
            <div role="tabpanel" className="tabs-content">
                {tabs[activeIndex].content}
            </div>
        </div>
         <div className="terms-text">
         <div className="contact_us">
         <a href={contactUsPage.url} target="_blank">צור קשר | </a>
         <a href={privacyPage.url} target="_blank"> מדיניות פרטיות | </a>
         <a href={termsPage.url} target="_blank"> תנאי שימוש</a> 
        </div>
        <span>לביטול מינוי ידיעות+ כדין יש לשלוח שם מלא וטלפון באחד מהאופנים הבאים: </span>
        <a href={contactUsPage.url}>מילוי טופס  </a> 
         או בדוא״ל   
         <a href="mailto://support.plus@yedioth.co.il"> support.plus@yedioth.co.il </a>    
         או בת.ד 438 ראשון לציון או בטל׳  3733* / 03-6933933 או         
         <div> 
            <span>   בפקס  </span>        
         <span>  03-6933999  </span>
         |  <span> ידיעות מינויים ח.פ  </span>
         <span>  540181054  </span>
         </div>
         </div>
         </div>
    );
};

export default PaywallMyAccountTabs